export default "__VITE_ASSET__cf01732d__"